import { useState, useEffect } from "react";
import API from "../api/axios";
import Layoutsecond from "../components/Layoutsecond";
import { Link } from "react-router-dom";

export default function Category() {
  const [categories, setCategories] = useState([]);
  const [ProjectCategoryDescription ,setProjectCategoryDescription] = useState();

  useEffect(() => {
    API.get("/categories")
      .then((res) => {
        if (res.data && res.data.success) {
          setCategories(res.data.data);
        }
      })
      .catch((err) => console.error("Category fetch failed:", err));
  }, []);

    useEffect(() => {
    API.get("/settings/")
      .then((res) => {
        const description = res.data.find(item => item.key === "project_category_description");
        if (description) {
          setProjectCategoryDescription(description.value);
        }
      })
      .catch((err) => {
        console.error("Error fetching settings:", err);
      });
  }, []);

  const getParentName = (parentId) => {
    const parent = categories.find((c) => c.id === parentId);
    return parent ? parent.name : "";
  };

  return (
    <Layoutsecond>
      {/* New Heading Section */}
      <div style={{ marginTop: "20px", marginBottom: "30px" }}>
        <h1 className="font-instrument text-xxxl md:text-[40px] text-center leading-[120%]">
          Project Category !
        </h1>

       <p
          className="category-subtitle"
          dangerouslySetInnerHTML={{ __html: ProjectCategoryDescription }}
        />

      </div>

      {/* Category Grid */}
      <div className="category-grid">
        {categories.map((cat, index) => (
          <Link
            key={index}
            to={`/category/${cat.slug}`}
            className="category-card"
          >
            <div className="category-text">
              <h2>
                {cat.name}{" "}
                {cat.parent_id && (
                  <span className="parent-category">
                    ( {getParentName(cat.parent_id)} )
                  </span>
                )}
              </h2>
             <p style={{fontWeight: 'bold'}}>{cat.projects_count} Projects</p>
              {cat.description && cat.description.trim() !== "" && (
                <p>
                  {cat.description.length > 100
                    ? `${cat.description.slice(0, 100)}...`
                    : cat.description}
                </p>
              )}
            </div>

            <div className="category-images">
              {(cat.projects || []).slice(0, 3).map((project, i) => (
                <img
                  key={i}
                  src={project.logo_url || "./default_project_img.png"}
                  alt={`${cat.name} Project ${i + 1}`}
                  style={{
                    zIndex: i,
                    marginLeft: i === 0 ? 0 : -28,
                    height: "80px",
                    width: i === 2 ? "140px" : "80px",
                    borderRadius: "10px",
                    border: "2px solid #f5f5f5",
                    background: "#fff",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    if (e.currentTarget.src !== "./default_project_img.png") {
                      e.currentTarget.src = "./default_project_img.png";
                    }
                  }}
                />
              ))}
            </div>
          </Link>
        ))}
      </div>
    </Layoutsecond>
  );
}
